
import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { LeagueDropdown } from '@/components/team-details/dropdowns/LeagueDropdown';
import { supabase } from '@/integrations/supabase/client';

interface LeagueFilterProps {
  selectedLeague: string | null;
  onLeagueSelect: (league: string) => void;
  leagues: string[];
}

const LeagueFilter: React.FC<LeagueFilterProps> = ({
  selectedLeague,
  onLeagueSelect,
  leagues
}) => {
  return (
    <div className="w-full flex justify-center">
      <LeagueDropdown
        leagues={leagues}
        selectedLeague={selectedLeague}
        onLeagueSelect={onLeagueSelect}
      />
    </div>
  );
};

export default LeagueFilter;
